class ComponentHeader extends Theme.Component {
  connectedCallback() {
    this.initHeaderHeight();
    this.initHeaderSentinel();
  }

  disconnectedCallback() {
    this.destroyHeaderSentinel();
    this.destroyHeaderHeight();

    super.disconnectedCallback();
  }

  initHeaderHeight() {
    this.updateHeaderHeightVar();

    if (this.headerResizeObserver) {
      this.headerResizeObserver.disconnect();
      this.headerResizeObserver = null;
    }

    this.headerResizeObserver = new ResizeObserver(() => {
      this.updateHeaderHeightVar();

      if (this.headerSentinelObserver) {
        this.initHeaderSentinel();
      }
    });

    this.headerResizeObserver.observe(this);
  }

  destroyHeaderHeight() {
    if (!this.headerResizeObserver) return;
    this.headerResizeObserver.disconnect();
    this.headerResizeObserver = null;
  }

  updateHeaderHeightVar() {
    const height = this.getBoundingClientRect().height || 0;
    document.documentElement.style.setProperty('--fixed-header-height', `${height}px`);
  }

  initHeaderSentinel() {
    const sentinel = document.querySelector('[data-header-sentinel]');
    if (!sentinel) return;

    if (this.headerSentinelObserver) {
      this.headerSentinelObserver.disconnect();
      this.headerSentinelObserver = null;
    }

    const headerHeight = this.getBoundingClientRect().height || 0;

    this.headerSentinelObserver = new IntersectionObserver(
      (entries) => this.onHeaderSentinelIntersect(entries),
      {
        root: null,
        threshold: 0,
        rootMargin: `${headerHeight}px 0px 0px 0px`
      }
    );

    this.headerSentinelObserver.observe(sentinel);
  }

  destroyHeaderSentinel() {
    if (!this.headerSentinelObserver) return;
    this.headerSentinelObserver.disconnect();
    this.headerSentinelObserver = null;
  }

  onHeaderSentinelIntersect(entries) {
    const entry = entries && entries[0];
    if (entry.isIntersecting) {
      this.classList.remove('is-scrolled');
      return;
    }

    this.classList.add('is-scrolled');
  }
}

customElements.define('component-header', ComponentHeader);